import React from 'react';
import classNames from 'classnames';

import { useAppSelector } from 'src/app/hooks';
import logo from './logo.svg';
import styles from './Logo.module.css';

import {
  selectIsFirstArea,
  selectSoundEnabled,
} from 'src/state';

interface Props {}

export function Logo(props: Props) {
  const isSoundEnabled = useAppSelector(selectSoundEnabled);
  const isFirstArea = useAppSelector(selectIsFirstArea);

  const classes = classNames(
    styles['logo'],
    {
      [styles['logo--with-sound']]: isSoundEnabled,
      [styles['logo--not-first-area']]: !isFirstArea,
    },
  );

  return (
    <div className={styles['logo-container']} >
      <img className={classes} src={logo} alt="Logo" />
    </div>
  );
}
